// extracted by mini-css-extract-plugin
module.exports = {"pageLayout":"Pr-z","mainContent":"Qr-z","activeSidebar":"Rr-z"};